export enum ArrowDirection {
  Up = 'up',
  Down = 'down'
}
